export default __webpack_public_path__ + "images/fr-81d43a151d8bc64145f25bc3d4cdc02a.svg";